import React from "react"
import MWSVG from "./common/svg"

type Props = {
  className?: string
}

const MenuBottomPanel: React.FC<Props> = ({ className }) => {
  return (
    <li
      className={`social-mail border-t border-light dark:border-[#4c5773] bg-white dark:bg-transparent dark:backdrop-blur-2xl lg:absolute bottom-0 right-0 z-10 ${className}`}
    >
      <div className="lg:flex flex-wrap items-center px-0 lg:px-4 py-5 lg:py-4 justify-end">
        <p className="flex items-center mb-0 text-body text-textcolor px-5 lg:px-0 py-2.5 lg:py-0">
          <span
            className="fw-500 mb-0 flex items-center gap-2 hover:text-blue cursor-pointer"
            onClick={() => {
              window.open("mailto:sales@moweb.com")
            }}
          >
            <MWSVG id="ic-email" />
            sales@moweb.com
          </span>
        </p>
      </div>
    </li>
  )
}

export default MenuBottomPanel
